import axios from "axios";
import { API } from "../../const";
import { normParam } from "../../tools";
const M_API = API + "/api";
// import { normParam } from '@/tools'
// import Vue from 'vue'

// const M_API = API + '/user'
const lc = window.localStorage;
const TOKEN = "token";
const RTOKEN = "rToken";

const store = {
  namespaced: true,
  state: {
    user: null,
    config: null,
    token: lc.getItem(TOKEN),
    rToken: lc.getItem(RTOKEN),
    permission: [],
    roles: [],
    meta: null,
    promiseRT: null,
    arrayOfRT: [],
    retryRefresh: true
  },
  getters: {
    user(state) {
      return state.user;
    },
    permission(state) {
      return state.permission;
    },
    userMeta(state) {
      return state.meta ? state.meta.users_meta : null;
    },
    roles(state) {
      return state.roles;
    },
    check(state) {
      return state.token;
    },
    token(state) {
      return state.token;
    },
    rToken(state) {
      return state.rToken;
    },
    promiseRT(state) {
      return state.promiseRT;
    },
    arrayOfRT(state) {
      return state.arrayOfRT;
    },
    retryRefresh(state) {
      return state.retryRefresh;
    }
  },
  mutations: {
    addArrayRT(state, val) {
      state.arrayOfRT.push(val);
    },
    setPromiseRT(state, val) {
      state.promiseRT = val;
      state.promiseRT.then(() => {
        //jalankan function request ulang API
        var y = state.arrayOfRT.map(f => f());

        //setelah semua promise y dijalankan set null
        Promise.allSettled(y)
          .then(() => {
            state.promiseRT = null;
            state.arrayOfRT = [];
          })
          .catch(() => {
            state.promiseRT = null;
            state.arrayOfRT = [];
          });
      });
    },
    retryRefresh(state, val) {
      state.retryRefresh = val;
    },
    login(state, { user, token, rToken }) {
      let u = {
        ...user
      };
      delete u.token;

      state.user = user;
      state.token = token;
      state.rToken = rToken;
      lc.setItem(TOKEN, token);
      lc.setItem(RTOKEN, rToken);
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.rToken = null;
      state.instansi_aktif = null;
      // state.role = null
      state.roles = [];
      state.permission = [];
      state.promiseRT = null;
      state.arrayOfRT = [];
      state.retryRefresh = true;

      lc.removeItem(TOKEN);
      lc.removeItem(RTOKEN);
      // lc.removeItem(INSTANSI_AKTIF)
      // lc.removeItem(ROLE)
      // if (Vue.prototype.$Tawk) {
      //   Vue.prototype.$Tawk.$hideWidget()
      //   Vue.prototype.$Tawk.$endChat()
      // }
    },
    setToken(state, { token }) {
      state.token = token;
      lc.setItem(TOKEN, token);
    },
    setrToken(state, { rToken }) {
      state.rToken = rToken;
      lc.setItem(RTOKEN, rToken);
    },
    delToken(state) {
      state.token = null;
      lc.removeItem(TOKEN);
    }
  },
  actions: {
    // eslint-disable-next-line
    get({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/user${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getPenggunaDiklat({}, { instansi_id, diklat_id, params }) {
      return axios
        .get(
          `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/user${normParam(
            params
          )}`
        )
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getDetilPenggunaDiklat({}, { instansi_id, diklat_id, params }) {
      return axios
        .get(`${M_API}/diklatuser${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getDosen({}, { instansi_id, diklat_id, kelas_id, params, is_all = true }) {
      var _url = `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kandidat`;
      return axios
        .get(`${_url}${normParam(params)}`)
        .then(res => {
          // jika all data, maka cek apakag ada paging
          // jika ada paging, maka load all
          if (is_all && res.data.last_page > 1) {
            var _u = [];
            for (
              var i = res.data.current_page + 1;
              i <= res.data.last_page;
              i++
            ) {
              _u.push(`${_url}${normParam({ ...params, page: i })}`);
            }
            return Promise.all(_u.map(_e => axios.get(_e))).then(a => {
              var _d = [];
              a.map(_a => _d.push(..._a.data.data));
              res.data.data = [...res.data.data, ..._d];
              return res.data;
            });
          } else return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKandidat({}, { instansi_id, diklat_id, kelas_id, params }) {
      var _url = `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kandidat`;
      return axios
        .get(`${_url}${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getAllUser({}, { instansi_id, diklat_id, params }) {
      return axios
        .get(
          `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kandidat${normParam(
            params
          )}`
        )
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getPeran({}, instansi_id) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/peran`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    searchUser({}, { params }) {
      return axios
        .get(`${M_API}/get_info_user${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    checkAvailable({}, { instansi_id, params }) {
      return axios
        .get(
          `${M_API}/instansi/${instansi_id}/user_by_email${normParam(params)}`
        )
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getAllGuru({}, params) {
      // return axios
      //   .get(`${M_API}/users${normParam(params)}`)
      //   .then(res => {
      //     return res.data;
      //   })
      //   .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    instansi({}, params) {
      return axios
        .get(`${M_API}/tenant${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    profil({ state }) {
      return axios
        .get(`${M_API}/profilku`)
        .then(res => {
          state.user = {
            ...res.data
          };
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    detail(_, user_id) {
      return axios.get(`${API}/users/${user_id}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    verify(_, token) {
      return axios.post(`${M_API}/verify`, token).then(res => {
        return res.data;
      });
    },
    link_password(_, data) {
      return axios.post(`${M_API}/link_password`, data).then(res => {
        return res.data;
      });
    },
    changePassword(_, data) {
      return axios.post(`${M_API}/ganti_password`, data).then(res => {
        return res.data;
      });
    },
    resetPassword(_, data) {
      return axios.post(`${M_API}/password`, data).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    create({}, { instansi_id, obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${instansi_id}/user/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(err => Promise.reject(err));
      } else {
        return axios
          .post(`${M_API}/instansi/${instansi_id}/user/`, obj)
          .then(res => {
            return res;
          })
          .catch(err => Promise.reject(err));
      }
    },
    // eslint-disable-next-line
    register(_, obj) {
      return axios
        .post(`${M_API}/register`, obj)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios.delete(`${API}/users/${item.user_id}`).then(res => {
        return res.data;
      });
    },
    refreshToken(_, { grant_type, client_id, client_secret, refresh_token }) {
      return axios
        .post(`${API}/oauth/token`, {
          grant_type,
          client_id,
          client_secret,
          refresh_token
        })
        .then(res => {
          return res.data;
        });
    },
    saveToken({ dispatch, commit }, token) {
      commit("setToken", token);
      // try get me
      return dispatch("fetch").catch(() => {
        commit("delToken", null);
        return Promise.reject();
      });
    },
    // eslint-disable-next-line
    login(
      { commit, dispatch, state },
      // eslint-disable-next-line
      { grant_type, client_id, client_secret, username, password, instansi_id }
    ) {
      return axios
        .post(`${API}/oauth/token`, {
          grant_type,
          client_id,
          client_secret,
          username,
          password,
          instansi_id
        })
        .then(res => {
          let token = res.data.access_token;
          let rToken = res.data.refresh_token;
          state.token = token;
          commit("login", {
            token,
            rToken
          });
          return dispatch("fetch");
        })
        .catch(err => {
          Promise.reject(err);
          return err;
        });
    },
    // eslint-disable-next-line
    logout({ commit }) {
      // return axios.get(`${BASE_API}/logout`)
      //   .then(() => {
      //     commit('logout')
      //   })
      commit("logout");
      return Promise.resolve();
    },
    // eslint-disable-next-line
    fetch({ state, dispatch }) {
      if (!state.token) return Promise.reject(null);
      else {
        if (state.user) {
          return Promise.resolve();
        } else {
          // state.user = { email: "test@test.com", nama: "Admin" };
          return axios.get(`${M_API}/self`).then(res => {
            state.user = {
              ...res.data,
              nama: res.data.name
            };
          });
        }
      }
    },
    // eslint-disable-next-line
    getRole({ state }) {
      return axios.get(`${API}/users/list-permissions`).then(res => {
        state.permission = res.data.data;
      });
    }
  }
};

export default store;
